// ------------------------
// ------ Button IDs ------
// ------------------------
export const FAQ_BUTTON_ID = 'faq_button'
export const READ_MORE_ARTICLES_BUTTON_ID = 'read_more_articles_button'
export const BACK_TO_BLOG_BUTTON_ID = 'back_to_blog_button'
export const SERVICE_PACKAGE_SELECT_BUTTON_ID = 'service_package_select_button'
export const SERVICE_PACKAGE_CHANGE_PLAN_BUTTON_ID = 'service_package_change_plan_button'

// ------------------------
// ------ Form Types ------
// ------------------------
export const REGISTRATION_FORM_TYPE = 'registration'

// ------------------------
// ------ Card IDs --------
// ------------------------
export const BLOG_CARD_ID = 'blog_card'
export const TESTIMONIAL_CARD_ID = 'testimonial_card'
export const SERVICE_PACKAGE_CARD_ID = 'service_package_card'

// ---------------------------
// ------ Component IDs ------
// ---------------------------
export const SERVICE_AREAS_CITY_CARD_COMPONENT_ID = 'service_areas_city_card_component'
export const SERVICE_PACKAGE_MODAL_DESKTOP_COMPONENT_ID = 'service_package_modal_component'
export const SERVICE_PACKAGE_MODAL_MOBILE_COMPONENT_ID = 'service_package_modal_mobile_component'

// ------------------------------
// ------ Banner/Alert IDs ------
// ------------------------------
export const ALERT_BANNER_EXPAND_BUTTON = 'alert_banner_expand_button'
export const ALERT_BANNER_COLLAPSE_BUTTON = 'alert_banner_collapse_button'
export const ALERT_BANNER_CLOSE_BUTTON = 'alert_banner_close_button'

// -----------------------------
// ------ Help Center IDs ------
// -----------------------------
export const HELP_CENTER_CARD_TITLE_LINK = 'help_center_card_title_link'
export const HELP_CENTER_CARD_ITEM_LINK = 'help_center_card_item_link'
export const HELP_CENTER_CARD_VIEW_ALL_LINK = 'help_center_card_view_all_link'

// -----------------------------------
// ------ Engagement Action IDs ------
// -----------------------------------
export const SERVICE_PACKAGE_MODAL_ENGAGEMENT_ACTION_ID = 'service_package_modal_opened_time'

// -----------------------------------
// ------ Conversion Event IDs -------
// -----------------------------------
export const FIBER_STATUS_DETERMINED = 'fiber_status_determined'
export const VIEW_ITEM = 'view_item'
export const ADD_TO_CART = 'add_to_cart'
export const PURCHASE = 'purchase'
